<template lang="pug">
  .width-100.pointer
    .field.inner.row.middle(@click='$emit("toggleClassMenu", isActive ? null : classCompleteness.classNumber)')
      checkbox.m-right-05(circle :checked='getCompletedClass(classCompleteness.classNumber)')
      h2.text-normal.prevent-select {{ $t("krea.progressBar.resourceMenu.class", {classNumber: classCompleteness.classNumber}) }}
      simple-svg.dropdown-icon.dark-gray-icon.m-top-05.m-left-05(
        :class='{active: isActive}'
        :filepath='dropdownIcon'
        width='18px'
        height='18px'
      )
    .sub(v-show='isActive')
      .field.inner-double.row.middle(v-for='field in type === "teacher" ? resourceTeacherClassRequiredFieldsList : resourceStudentClassRequiredFieldsList')
        checkbox.m-right-05(circle :checked='getCompletedClassField(resourceCompleteness, classNumber, field)')
        h2.text-normal.prevent-select(@click='scrollTo(field)') {{ $t(`krea.progressBar.resourceClassMenu.${field}`) }}
</template>

<script>
import {
  resourceTeacherClassRequiredFieldsList,
  resourceStudentClassRequiredFieldsList,
  getCompletedClassField,
  resourceFieldsRoutes
} from '../../../../constants/kreaResource'
import Checkbox from '@/components/Inputs/Checkbox'
import dropdownIcon from '@/assets/ic_chevron-down.svg'

export default {
  components: { Checkbox },
  props: {
    type: { type: String },
    resourceId: { type: Number },
    classNumber: { type: Number },
    resourceCompleteness: { type: Object },
    isActive: { type: Boolean }
  },
  data() {
    return {
      resourceTeacherClassRequiredFieldsList,
      resourceStudentClassRequiredFieldsList,
      dropdownIcon,
      getCompletedClassField,
      activeDropdown: false
    }
  },
  computed: {
    classCompleteness() {
      return this.resourceCompleteness.classPlans.find(resClass => resClass.classNumber === this.classNumber)
    }
  },
  methods: {
    setActiveDropdown() {
      this.activeDropdown = !this.activeDropdown
    },
    getCompletedClass() {
      const allFields = this.type === 'teacher' ? resourceTeacherClassRequiredFieldsList : resourceStudentClassRequiredFieldsList
      return allFields.filter(field => getCompletedClassField(this.resourceCompleteness, this.classNumber, field)).length === allFields.length
    },
    scrollTo(field) {
      this.$emit('clickedField')
      if (field === 'necessaryMaterials' && this.type === 'teacher') {
        if (this.$route.name === resourceFieldsRoutes.necessaryMaterialsTeacher &&
        this.$route.params.id === this.resourceId) return this.redirectToField(field)
        else {
          return this.$router.push({
            name: resourceFieldsRoutes.necessaryMaterialsTeacher,
            params: { id: this.resourceId, classId: this.classCompleteness.classNumber, fieldRedirection: field }
          })
        }
      } else if (field === 'necessaryMaterials' && this.type === 'student') {
        if (this.$route.name === resourceFieldsRoutes.necessaryMaterialsStudent &&
        this.$route.params.id === this.resourceId) return this.redirectToField(field)
        else {
          return this.$router.push({
            name: resourceFieldsRoutes.necessaryMaterialsStudent,
            params: { id: this.resourceId, classId: this.classCompleteness.classNumber, fieldRedirection: field }
          })
        }
      } else {
        if (this.$route.name === resourceFieldsRoutes[field] &&
        this.$route.params.id === this.resourceId) return this.redirectToField(field)
        else {
          return this.$router.push({
            name: resourceFieldsRoutes[field],
            params: {
              id: this.resourceId,
              classId: this.classCompleteness.classNumber,
              fieldRedirection: field
            }
          })
        }
      }
    },
    redirectToField(field) {
      const element = document.getElementById(field)
      const navbarOffset = 90
      const progressBarOffset = 90
      const elementPosition = element.getBoundingClientRect().top
      const offsetPosition = elementPosition + window.pageYOffset - (navbarOffset + progressBarOffset)

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      })
      element.classList.add('highlight')
      setTimeout(() => {
        element.classList.remove('highlight')
      }, 1500)
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/variables/colors.scss';

.field{
  padding: 5px 8px;
  &:not(:last-child){
    border-bottom: 1px solid $light-gray;
  }
  &.inner{
    padding-left: 25px;
    border-bottom: 1px solid $light-gray;
  }
  &.inner-double{
    padding-left: 45px;
    border-bottom: 1px solid $light-gray;
  }
}

.dropdown-icon{
  transition: transform .5s ease;
  &.active{
    transform: rotate(180deg);
  }
}
</style>
